import ComprehensiveSolutions from "../../../component/servicescomponents/servicespagescomponents/ComprehensiveSolutions";
import SoftwareHero from "../../../component/servicescomponents/servicespagescomponents/SoftwareHero";
import FeatureShowcase from "../../../component/servicescomponents/servicespagescomponents/FeatureShowcase";
import DeliveryRoadmap from "../../../component/servicescomponents/servicespagescomponents/DeliveryRoadmap";
import TechnicalArsenal from "../../../component/servicescomponents/servicespagescomponents/TechnicalArsenal";
function Services() {
  return (
    <>
      {/* Static Sections */}
      <SoftwareHero/>
      <ComprehensiveSolutions/>
      <FeatureShowcase/>
      <DeliveryRoadmap/>
      <TechnicalArsenal/>
    </>
  );
}

export default Services;
